var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 176.97 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.66,40.65H136.32V13.31A13.33,13.33,0,0,0,123,0H57.88a13.2,13.2,0,0,0-9.41,3.9L3.9,48.47A13.18,13.18,0,0,0,0,57.88V146a13.32,13.32,0,0,0,13.31,13.31H40.65v27.34A13.32,13.32,0,0,0,54,200h109.7A13.32,13.32,0,0,0,177,186.69V54A13.32,13.32,0,0,0,163.66,40.65ZM13.31,147.47A1.44,1.44,0,0,1,11.88,146V60.43a3,3,0,0,1,3-3H47.49A10.27,10.27,0,0,0,57.77,47.18V14.86a3,3,0,0,1,3-3H123a1.44,1.44,0,0,1,1.43,1.43V40.66H98.54a13.21,13.21,0,0,0-9.41,3.89L44.55,89.13a13.23,13.23,0,0,0-3.89,9.41v48.93Zm151.78,39.22a1.43,1.43,0,0,1-1.43,1.43H54a1.44,1.44,0,0,1-1.43-1.43V101.08a3,3,0,0,1,3-3H88.15A10.27,10.27,0,0,0,98.42,87.83V55.51a3,3,0,0,1,3-3h62.26A1.44,1.44,0,0,1,165.09,54V186.69Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.438cf79c672a08dbce078caf71c65f24.svg";
export { ForwardRef as ReactComponent };